import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Paper, Typography } from '@mui/material';

const TestSmartRedirect: React.FC = () => {
  const navigate = useNavigate();

  const testUrls = [
    {
      label: 'Test CG - Recherche automatique',
      url: '/smart-redirect?target=/list-cg&regPlate=AB-123-CD&type=cg',
      description: 'Redirige vers la liste CG avec recherche automatique de la plaque AB-123-CD',
    },
    {
      label: 'Test DA - Recherche automatique',
      url: '/smart-redirect?target=/list-da&regPlate=XY-789-ZW&type=da',
      description: 'Redirige vers la liste DA avec recherche automatique de la plaque XY-789-ZW',
    },
    {
      label: 'Test CG - Redirection login',
      url: '/smart-redirect?target=/list-cg&regPlate=EF-456-GH&type=cg',
      description: 'Redirection vers login puis vers la liste CG avec recherche automatique',
    },
    {
      label: 'Test CG - Plaque inexistante',
      url: '/smart-redirect?target=/list-cg&regPlate=ZZ-999-ZZ&type=cg',
      description: "Test avec une plaque qui n'existe pas (pour vérifier la gestion d'erreur)",
    },
    {
      label: 'Test DA - Plaque inexistante',
      url: '/smart-redirect?target=/list-da&regPlate=ZZ-999-ZZ&type=da',
      description: "Test avec une plaque qui n'existe pas (pour vérifier la gestion d'erreur)",
    },
  ];

  return (
    <Box sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h4" sx={{ mb: 3, textAlign: 'center' }}>
        🧪 Test SmartRedirect
      </Typography>

      <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
        Ce composant permet de tester le système de redirection intelligente qui vérifie automatiquement l'état de
        connexion de l'utilisateur.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {testUrls.map((test, index) => (
          <Paper key={index} sx={{ p: 3, border: '1px solid #e0e0e0' }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              {test.label}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {test.description}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Button variant="contained" onClick={() => navigate(test.url)} sx={{ minWidth: 200 }}>
                Tester cette URL
              </Button>
              <Typography
                variant="body2"
                fontFamily="monospace"
                sx={{
                  backgroundColor: '#f5f5f5',
                  p: 1,
                  borderRadius: 1,
                  fontSize: '0.8rem',
                }}
              >
                {test.url}
              </Typography>
            </Box>
          </Paper>
        ))}
      </Box>

      <Paper sx={{ p: 3, mt: 4, backgroundColor: '#f8f9fa' }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          📋 Comment ça fonctionne ?
        </Typography>
        <Box component="ul" sx={{ pl: 2 }}>
          <li>
            Si l'utilisateur est <strong>connecté</strong> : redirection directe vers la destination avec ouverture du
            drawer
          </li>
          <li>
            Si l'utilisateur est <strong>non connecté</strong> : redirection vers la page de login, puis vers la
            destination après connexion
          </li>
          <li>
            Le système utilise la route <code>/smart-redirect</code> qui analyse automatiquement l'état de connexion
          </li>
          <li>
            Les paramètres <code>target</code>, <code>regPlate</code> et <code>type</code> sont transmis via l'URL
          </li>
          <li>
            <strong>Nouveau :</strong> Recherche automatique par plaque d'immatriculation avec ouverture du drawer
          </li>
        </Box>
      </Paper>
    </Box>
  );
};

export default TestSmartRedirect;
